export const CAR_MODELS = {
  "Toyota": ["Corolla", "Camry", "Yaris", "RAV4", "Kluger", "Prado", "LandCruiser", "Hilux", "HiAce", "C-HR"],
  "Honda": ["Civic", "Accord", "CR-V", "HR-V", "Jazz", "Odyssey"],
  "Ford": ["Ranger", "Everest", "Mustang", "Focus", "Fiesta", "Transit", "Puma", "Escape"],
  "Hyundai": ["i20", "i30", "Tucson", "Santa Fe", "Kona", "Palisade", "Elantra", "Sonata", "Staria"],
  "Kia": ["Cerato", "Sportage", "Sorento", "Carnival", "Rio", "Picanto", "Stinger", "Seltos", "EV6"],
  "Mazda": ["Mazda3", "Mazda6", "CX-3", "CX-30", "CX-5", "CX-8", "CX-9", "BT-50", "MX-5"],
  "Mitsubishi": ["Triton", "Outlander", "Pajero Sport", "ASX", "Eclipse Cross", "Lancer", "Mirage"],
  "Nissan": ["Navara", "X-Trail", "Qashqai", "Pathfinder", "Patrol", "Juke", "Leaf"],
  "Volkswagen": ["Golf", "Polo", "Tiguan", "Amarok", "Touareg", "T-Roc", "T-Cross", "Passat", "Transporter"],
  "Subaru": ["Forester", "Outback", "XV", "Impreza", "WRX", "BRZ", "Crosstrek"],
  "Isuzu": ["D-MAX", "MU-X"],
  "Mercedes-Benz": ["A-Class", "C-Class", "E-Class", "GLC", "GLE", "Sprinter", "Vito"],
  "BMW": ["1 Series", "3 Series", "5 Series", "X1", "X3", "X5"],
  "Audi": ["A3", "A4", "Q3", "Q5", "Q7"],
  "Tesla": ["Model 3", "Model Y", "Model S", "Model X"],
  "MG": ["MG3", "ZST", "HS", "MG4"],
  "GWM": ["Cannon", "Haval H6", "Haval Jolion", "Tank 300"],
  "LDV": ["T60", "D90", "Deliver 9", "G10"],
  "Renault": ["Koleos", "Captur", "Megane", "Kangoo", "Master", "Trafic"],
  "Suzuki": ["Swift", "Jimny", "Vitara", "Ignis", "Baleno"],
  "Lexus": ["NX", "RX", "UX", "IS", "ES"],
  "Jeep": ["Grand Cherokee", "Wrangler", "Compass", "Gladiator"],
  "Volvo": ["XC40", "XC60", "XC90"]
};
